import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { usePageTitle } from "@/lib/usePageTitle";

const CATS = ["All", "Building", "Cleaning", "Electrical", "Gardening", "Handyman", "Painting", "Plumbing", "Renovation", "Roofing"];
const TYPES = [["All", "All"], ["instant", "Instant book"], ["quote", "By quote"]];

export default function Services() {
  const [services, setServices] = useState([]);
  const [cat, setCat] = useState("All");
  const [type, setType] = useState("All");
  const navigate = useNavigate();
  usePageTitle("Services — Olivia Does");

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);

  const filtered = services.filter((s) =>
    (cat === "All" || s.category === cat) && (type === "All" || s.type === type)
  );

  return (
    <section className="od-section od-wrap" data-testid="services-page">
      <div className="od-eyebrow">Service catalogue</div>
      <h1 className="serif" style={{ fontSize: "2.4rem", fontWeight: 500, margin: "0 0 14px" }}>Browse what Olivia handles.</h1>
      <p style={{ color: "var(--taupe)", maxWidth: 560, marginBottom: 24 }}>Fixed-price instant bookings for everyday tasks, or request a quote for bespoke projects. One concierge, one standard.</p>

      <div className="pillrow">
        {TYPES.map(([val, label]) => (
          <div key={val} data-testid={`svc-type-${val}`} className={`pill ${type === val ? "on" : ""}`} onClick={() => setType(val)}>{label}</div>
        ))}
      </div>
      <div className="pillrow" style={{ marginBottom: 34 }}>
        {CATS.map((c) => (
          <div key={c} data-testid={`svc-cat-${c.toLowerCase()}`} className={`pill ${cat === c ? "on" : ""}`} onClick={() => setCat(c)}>{c}</div>
        ))}
      </div>

      <div className="ogrid cols-3">
        {filtered.map((s) => (
          <div className="svc" key={s.id} data-testid={`svc-${s.id}`}>
            <div className="tags">
              <span className={`tag ${s.type}`}>{s.type === "instant" ? "INSTANT" : "QUOTE"}</span>
            </div>
            <h4>{s.name}</h4>
            <p className="desc">{s.description}</p>
            <div className="bottom">
              <div className="price">{s.price != null ? `£${s.price}` : "By quote"}<small>{s.duration}</small></div>
              <button className="btn primary sm" data-testid={`svc-book-${s.id}`} onClick={() => navigate(`/book?service=${s.id}`)}>{s.type === "instant" ? "Book" : "Get quote"}</button>
            </div>
          </div>
        ))}
      </div>
      {filtered.length === 0 && <p style={{ color: "var(--taupe)", padding: "30px 0" }}>No services match that combination — try a different filter.</p>}
    </section>
  );
}
